<template>
	<div>
		<v-skeleton-loader
			type="list-item, list-item, list-item"
			v-if="loadingFiles"
		></v-skeleton-loader>
		<template v-else>
			<div
				v-for="message in ConversationFiles"
				:key="message.MessageId"
				class="mb-2 pa-2 fileListItem"
			>
				<v-img
					class="rounded mr-2 grey lighten-2"
					contain
					:src="message.Attributes.FilePreviewUrl"
					v-if="message.Attributes.FilePreviewUrl"
					max-height="50"
					max-width="70"
				>
					<template v-slot:placeholder>
						<v-row
							class="fill-height ma-0"
							align="center"
							justify="center"
						>
							<v-progress-circular
								indeterminate
								color="grey lighten-5"
							></v-progress-circular>
						</v-row>
					</template>
				</v-img>

				<div class="truncate">
					<a
						:href="message.Attributes.FileUrl"
						class=" poppins-medium"
						:class="{
							'blue--text text--lighten-1': message.AuthorId === UserId,
							'green--text text--darken-3':
								message.AuthorId !== UserId
						}"
						target="_blank"
					>
						<v-icon
							v-if="!message.Attributes.FilePreviewUrl"
							class="mr-3"
							:color="
								message.AuthorId === UserId
									? 'blue lighten-1'
									: 'green darken-3'
							"
							>{{
								getFileIcon(message.Attributes.FileDisplayName)
							}}</v-icon
						>
						{{ message.Attributes.FileDisplayName }}</a
					>
				</div>
			</div>
		</template>

		<div
			class="text-center"
			v-if="!loadingFiles && ConversationFiles.length === 0"
		>
			Nessun file in questa conversazione
		</div>
	</div>
</template>

<script>
import CrudClient from "@/services/CrudClient";
import { getFileIcon } from "./fileIcons";

export default {
	name: "SentReceivedFiles",
	data() {
		return {
			ConversationFiles: [],
			loadingFiles: false
		};
	},
	props: {
		UserId: {
			required: true
		}
	},
	created() {
		this.chatService = new CrudClient("Chat");
	},
	async mounted() {
		await this.loadFiles();
	},
	methods: {
		async loadFiles() {
			this.loadingFiles = true;
			try {
				const incomingData = await this.chatService.Get(
					null,
					`Files/${this.UserId}`
				);

				// transform the incoming data to twilio format
				this.ConversationFiles = incomingData.map(m => ({
					// conversationSid: m.ConversationSid,
					sid: m.MessageSid,
					body: m.Body,
					author: m.AuthorId,
					index: m.MessageIndex,
					attributes: JSON.parse(m.Attributes),
					timestamp: m.DateCreated,
					liveConversation: m.ConversationSid === this.ConversationSid
				}));
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
			} finally {
				this.loadingFiles = false;
			}
		},

		getFileIcon(filename) {
			return getFileIcon(filename);
		}
	}
};
</script>

<style scoped lang="scss">

.fileListItem{
	&:hover{
		border-radius: 5px;
		background-color: #EEEEEE;
	}
}

</style>
